import React from 'react';

function EntryCard({ entry, onEdit, onDelete, isDeleting }) {
  return (
    <div className="entry-card">
      <div className="entry-header">
        <h3 className="entry-name">{entry.name}</h3>
        <div className="entry-actions">
          <button 
            onClick={() => onEdit(entry)} 
            className="btn-icon" 
            title="Edit"
            disabled={isDeleting}
          >
            Edit
          </button>
          <button 
            onClick={() => onDelete(entry.id)} 
            className="btn-icon" 
            title="Delete"
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <span className="spinner-small"></span>
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </button>
        </div>
      </div>
      
      {entry.guests && (
        <div className="entry-info">
          <span className="entry-label">Guests:</span>
          <span className="entry-value">{entry.guests}</span>
        </div>
      )}
      
      {entry.dishes && (
        <div className="entry-info">
          <span className="entry-label">Bringing:</span>
          <span className="entry-value">{entry.dishes}</span>
        </div>
      )}
      
      {!entry.guests && !entry.dishes && (
        <div className="entry-info empty">
          <span>No additional details provided</span>
        </div>
      )}
    </div>
  );
}

export default EntryCard;

